const actions = {
  LIST_ESQUEMAS_CONTRACTUALES: 'LIST_ESQUEMAS_CONTRACTUALES',
  LIST_ESQUEMAS_CONTRACTUALES_SELECTBOX: 'LIST_ESQUEMAS_CONTRACTUALES_SELECTBOX',
  CREATE_ESQUEMAS_CONTRACTUALES: 'CREATE_ESQUEMAS_CONTRACTUALES',
  READ_ESQUEMAS_CONTRACTUALES: 'READ_ESQUEMAS_CONTRACTUALES',
  UPDATE_ESQUEMAS_CONTRACTUALES: 'UPDATE_ESQUEMAS_CONTRACTUALES',
  DELETE_ESQUEMAS_CONTRACTUALES: 'DELETE_ESQUEMAS_CONTRACTUALES',


  esquemasContractualesList: data => {     
    return {
      type: actions.LIST_ESQUEMAS_CONTRACTUALES,
      data,
    };
  },

  esquemasContractualesListSelectBox: data => {
    return {
      type: actions.LIST_ESQUEMAS_CONTRACTUALES_SELECTBOX,
      data,
    };
  },

  esquemasContractualesCreate: data => {
    return {
      type: actions.CREATE_ESQUEMAS_CONTRACTUALES,
      data,
    };
  },

  esquemasContractualesRead: data => {
    return {
      type: actions.READ_ESQUEMAS_CONTRACTUALES,
      data,
    };
  },

  esquemasContractualesUpdate: data => {
    return {
      type: actions.UPDATE_ESQUEMAS_CONTRACTUALES,
      data,
    };
  },

  esquemasContractualesDelete: () => {
    return {
      type: actions.DELETE_ESQUEMAS_CONTRACTUALES,      
    };
  },
};

export default actions;
